module.exports = __webpack_public_path__ + "img/aaa.ae5bc883.png";